import { IIconProps } from 'src/interfaces/Icon';

const SettingsIconMedium = ({ width = 22, height = 20, color = '#fff', ...props }: IIconProps) => (
  <svg
    data-testid='settings-icon-medium'
    width={width}
    height={height}
    viewBox='0 0 22 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      // eslint-disable-next-line max-len
      d='M17.8307 1.4075L21.5532 8.46632C22.1489 9.40783 22.1489 10.5922 21.5532 11.5337L17.8307 18.5925C17.2775 19.4668 16.293 20 15.232 20H6.768C5.70702 20 4.7225 19.4668 4.16925 18.5925L0.446845 11.5337C-0.148949 10.5922 -0.148948 9.40783 0.446845 8.46632L4.16925 1.4075C4.7225 0.533221 5.70702 0 6.768 0H15.232C16.293 0 17.2775 0.533222 17.8307 1.4075ZM20.6686 11.0672L16.9665 18.0875C16.5985 18.6461 15.9482 19 15.232 19H6.768C6.05183 19 5.4015 18.6461 5.03345 18.0875L1.33139 11.0672L1.31297 11.0323L1.29186 10.9989C0.902712 10.384 0.902712 9.61602 1.29186 9.00106L1.31298 8.9677L1.33139 8.93278L5.03345 1.91253C5.4015 1.3539 6.05183 1 6.768 1H15.232C15.9482 1 16.5985 1.3539 16.9665 1.91251L20.6686 8.93278L20.687 8.9677L20.7081 9.00106C21.0973 9.61602 21.0973 10.384 20.7081 10.9989L20.687 11.0323L20.6686 11.0672ZM14 10C14 11.6569 12.6569 13 11 13C9.34315 13 8 11.6569 8 10C8 8.34315 9.34315 7 11 7C12.6569 7 14 8.34315 14 10ZM15 10C15 12.2091 13.2091 14 11 14C8.79086 14 7 12.2091 7 10C7 7.79086 8.79086 6 11 6C13.2091 6 15 7.79086 15 10Z'
      fill={color}
    />
  </svg>
);
export default SettingsIconMedium;
